module.exports = __webpack_public_path__ + "img/ActivationCodeField.7160b748.jpg";